// extracted by mini-css-extract-plugin
export default {"section":"CommandPalette_section__gDkzg","actions":"CommandPalette_actions__rYcbN"};